
import { SearchCriteria } from "../../search-criterias/search-criteria";

export class ClientLastVisitInfoSearchCriteria extends SearchCriteria {
  public BookingId: number;
  public BillId: number;
}
